/**
 * Generated by orval 🍺
 * Do not edit manually.
 * raisy
 * Kernel/Bot System for raisy
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ApiRoutesWaitlistManagerApiResponse,
  HTTPValidationError,
  WaitlistJoinRequest
} from '../../models';

import { apiClient } from '../../../apiClient';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getJoinWaitlistApiV1WaitlistJoinPostUrl = () => {




  return `/api/v1/waitlist/join`
}

/**
 * @summary Join Waitlist
 */
export const joinWaitlistApiV1WaitlistJoinPost = async (waitlistJoinRequest: WaitlistJoinRequest, options?: Parameters<typeof apiClient>[1]): Promise<ApiRoutesWaitlistManagerApiResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiClient<ApiRoutesWaitlistManagerApiResponse>(getJoinWaitlistApiV1WaitlistJoinPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(waitlistJoinRequest)
  }
);}





export const getJoinWaitlistApiV1WaitlistJoinPostMutationKey = () => ['joinWaitlistApiV1WaitlistJoinPost'] as const;

export const getJoinWaitlistApiV1WaitlistJoinPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWaitlistApiV1WaitlistJoinPost>>, TError,JoinWaitlistApiV1WaitlistJoinPostMutationVariables, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof joinWaitlistApiV1WaitlistJoinPost>>, TError,JoinWaitlistApiV1WaitlistJoinPostMutationVariables, TContext> => {

const mutationKey = getJoinWaitlistApiV1WaitlistJoinPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinWaitlistApiV1WaitlistJoinPost>>, JoinWaitlistApiV1WaitlistJoinPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  joinWaitlistApiV1WaitlistJoinPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinWaitlistApiV1WaitlistJoinPostMutationResult = NonNullable<Awaited<ReturnType<typeof joinWaitlistApiV1WaitlistJoinPost>>>
    export type JoinWaitlistApiV1WaitlistJoinPostMutationBody = WaitlistJoinRequest
    export type JoinWaitlistApiV1WaitlistJoinPostMutationError = HTTPValidationError
    export type JoinWaitlistApiV1WaitlistJoinPostMutationVariables = {data: WaitlistJoinRequest}

    /**
 * @summary Join Waitlist
 */
export const useJoinWaitlistApiV1WaitlistJoinPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWaitlistApiV1WaitlistJoinPost>>, TError,JoinWaitlistApiV1WaitlistJoinPostMutationVariables, TContext>, request?: SecondParameter<typeof apiClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof joinWaitlistApiV1WaitlistJoinPost>>,
        TError,
        JoinWaitlistApiV1WaitlistJoinPostMutationVariables,
        TContext
      > => {
      return useMutation(getJoinWaitlistApiV1WaitlistJoinPostMutationOptions(options), queryClient);
    }
